import LOCAL_ENV from "./environment.local";
import PROD from "./environment.production";
import TEST from "./enviroment.test";
import DEV from "./environment.dev";
import { IAppConfiguration } from "./IAppConfiguration";
import { Environment } from "./Environment";
export const getAppConfiguration = () => {
  const NODE_ENV = process.env.REACT_APP_API_BASE_URL
  switch (NODE_ENV) {
    case Environment.PROD:
      return { ...PROD } as IAppConfiguration
    case Environment.DEV:
      return { ...DEV } as IAppConfiguration
    case Environment.TEST:
      return { ...TEST } as IAppConfiguration
    default:
      return { ...LOCAL_ENV } as IAppConfiguration
  }
}